import { FiBell } from "react-icons/fi";
import { FcBusinessman } from "react-icons/fc";
import { AiOutlineMail } from "react-icons/ai";
import { RiArrowDropDownLine } from "react-icons/ri";
import { AiOutlineMenu } from "react-icons/ai";
import { connect, useDispatch, useSelector } from "react-redux";
import { FcBusinesswoman } from "react-icons/fc";
import { FcBearish } from "react-icons/fc";
import UserAvatar from "react-user-avatar";
import React, { useRef, useEffect, useState } from "react";
import "../Assets/Css/Navbar.scss";
import { sidebarOpen } from '../Services/Sidebar/action'
import { Link, useNavigate } from "react-router-dom";
import { BsPauseCircleFill } from "react-icons/bs";
import { FaStopCircle } from "react-icons/fa";
import { updateTask } from "../Services/Task/action";
import { getDashboardData } from "../Services/Dashboard/action";
import { FaCirclePlay } from "react-icons/fa6";
import useTimerStore from "../Lib/timerStore";
import { Spinner } from "react-bootstrap";
import ActiveTimeIcon from "../Assets/Images/Employee/Active-Timer.svg";
import ActiveTaskModal from "./ActiveTaskModal";
import { getRunningTaskList } from "../Services/Task/action";
const Navbar = ({ getDashboardData, user, dashboardData, updateTask, getRunningTaskList }) => {
  const isOpen = useSelector(state => state.sidebarReducer.isOpen);
  const dispatch = useDispatch();
  const { pause, resume, stop, updateTimer, reset, getTimerState } = useTimerStore();
  function menuIconClick() {
    dispatch(sidebarOpen());
  }
  const [show, setShow] = useState(false);
  const [sshow, setSshow] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);
  const [isActiveTaskModalVisible, setIsActiveTaskModalVisible] =
    useState(false);
  const [runningTasksList, setRunningTasksList] = useState([]);
  const [loadingRunningTasks, setLoadingRunningTasks] = useState(false);
  const userProfilePic = localStorage.getItem("userProfilePic");

  const timerData = ((currentTask?.employee_id == user?.id) && currentTask?.task_id)
    ? getTimerState(currentTask.employee_id, currentTask.task_id)
    : null;
  const fetchData = async () => {
    const local_user = JSON.parse(localStorage?.getItem('user'));

    await getDashboardData(local_user?.id);
  }
  useEffect(() => {
    setShow(false);
    setSshow(false);
    // if (user?.id) {
    setTimeout(() => {
      fetchData();
    }, 100)
    // }
  }, [])


  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShow(false);
        }
      }
      function handleClickOutside2(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSshow(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("mousedown", handleClickOutside2);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("mousedown", handleClickOutside2);

      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.removeItem('user')
    localStorage.removeItem('userProfilePic')
    reset()
    localStorage.removeItem('timer-storage')
    navigate('/login')
  }

  useEffect(() => {
    if (dashboardData?.filteredtask?.length > 0) {
      setCurrentTask(dashboardData?.filteredtask?.[0])
      const task = dashboardData?.filteredtask?.[0];
      if (task) {
        const key = `${task.employee_id}_${task.task_id}`;
        useTimerStore.setState(state => ({
          timers: {
            ...state.timers,
            [key]: {
              ...state.timers[key],
              taskId: task.task_id,
              startTime: task.start_time,
              status: task?.state,
              actionHistory:
                typeof task.action_history === "string"
                  ? JSON.parse(task.action_history)
                  : task.action_history || [],
            },
          },
        }));
      }
    }
    else {
      reset();
      localStorage?.removeItem('timer-storage')
    }
  }, [dashboardData?.filteredtask, dashboardData?.allTasks])

  const handleTimer = async (status) => {
    try {
      const taskId = currentTask?.task_id;

      if (!taskId) return;

      const timestamp = new Date();
      if (status === "resume") {
        resume(user?.id, taskId);
        updateTimer(user?.id, taskId)
        await updateTask(currentTask?.id, { resume_time: timestamp, employee_id: user?.id, task_id: taskId }, true)
      }
      else if (status === "pause") {
        pause(user?.id, taskId);
        updateTimer(user?.id, taskId)
        await updateTask(currentTask?.id, { pause_time: timestamp, employee_id: user?.id, task_id: taskId }, true);
      }
      else {
        stop(updateTask, user?.id, currentTask?.id, taskId, 0, false);
        updateTimer(user?.id, taskId);
      }
    } catch (error) {
      console.error("Error updating task timer :", error);
    }
  }
  const fetchRunningTasks = async () => {
    try {
      setLoadingRunningTasks(true);
      const response = await getRunningTaskList();
      setRunningTasksList(response.data || []);
    } catch (error) {
      console.error("Error fetching running tasks:", error);
      setRunningTasksList([]);
    } finally {
      setLoadingRunningTasks(false);
    }
  }
  const handleActiveTaskIconClick = async () => {
    await fetchRunningTasks();
    setIsActiveTaskModalVisible(true);
  }
  useEffect(() => {

    let interval;
    if (timerData?.status != null && timerData?.status != 'stopped') {
      interval = setInterval(() => {
        updateTimer(currentTask?.employee_id, currentTask?.task_id)
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerData?.status, currentTask, dashboardData?.filteredtask, dashboardData?.allTasks])

  const hasActiveTimeIconAccess = () => {
    const allowedRoles = ['hr_senior', 'hr_junior', 'hr', 'admin'];
    return user?.role?.name && allowedRoles.includes(user.role.name);
  };
  return (
    <>
      <div className="parent">
        <div className="left-part">
          {isOpen && <div className={`${isOpen ? "outside-closed" : "outside"}`} >
            <AiOutlineMenu onClick={menuIconClick} />
          </div>}
        </div>

        <div className="right-part">
          {(timerData?.status != null && timerData?.status != "stopped") && (
            <div className="timer-btn d-flex align-items-center justify-content-evenly">
              {timerData?.timer == null ? <Spinner as="span" animation="border" role="status" aria-hidden="true" size="sm" /> : <h4 className="time">{timerData?.timer}</h4>}
              <div className='icon-container'>
                {timerData?.status === "paused" ?
                  (
                    <div className="play-icon">
                      <FaCirclePlay onClick={() => handleTimer("resume")} />
                    </div>
                  ) : (
                    <div className="pause-icon">
                      <BsPauseCircleFill onClick={() => handleTimer("pause")} />
                    </div>
                  )}
                <div className="stop-icon">
                  <FaStopCircle onClick={() => handleTimer("stop")} />
                </div>
              </div>
            </div>)}
          {/* <div className="bell-icon notification-part">
            <button onClick={() => setShow(true)} className="bt">
              <FiBell className="bel" />
            </button>
            {show ? (
              <div ref={wrapperRef}>
                <div className="notification-hover-block">
                  <div className="notifiction-custom-part">
                    <div className="hover-block">
                      <div className="squre">
                        <div className="popup-heding">
                          Notifictions
                          <div className="notifiction-count">5 new</div>
                        </div>
                        <div className="notification-scroll">
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinesswoman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinessman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!{" "}
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBearish />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinesswoman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel currentl dddqwqwe{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bell-popup-btn">
                          <button className="btn-width">
                            See All Notifiction
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div> */}
          {hasActiveTimeIconAccess() && (
            <div className="active-timer">
              <img
                src={ActiveTimeIcon}
                className="employee-icon"
                alt="Active Tasks"
                onClick={handleActiveTaskIconClick}
                style={{ cursor: "pointer" }}
              />
            </div>
          )}

          <div className="line"></div>
          <button onClick={() => setSshow(true)} className="bbt cor">

            <div className="profile">
              {/* <button className="bt-1">A</button> */}
              {
                userProfilePic ? <img src={userProfilePic} width={30} height={30} style={{ borderRadius: "50%" }} alt="User" /> : <UserAvatar size="30" name={(user && user?.name) || 'CD'} color="#5757fe" />
              }
            </div>
            <div className="email">
              <div className="name">
                {" "}
                {user && user?.name || ""} <RiArrowDropDownLine className="cor" />
              </div>
            </div>
          </button>

          {sshow ? (
            <div ref={wrapperRef}>
              <div className="prodiv">
                <ul className="unordered-list">
                  <div className="user-profile">
                    <h4 className="card-heading">User Profile</h4>
                  </div>
                  {/* ---------account div-------- */}
                  <div className="dsp">
                    <div className="avatar">
                      {
                        userProfilePic ? <img src={userProfilePic} width={80} height={80} style={{ borderRadius: "50%" }} alt="User" /> : <UserAvatar size="80" name={(user && user?.name) || 'cd'} color="#5757fe" />
                      }
                    </div>
                    <div className="alll">
                      <div>
                        <h4 className="jlr">{user && user?.name || ""}</h4>
                        <h6 className="adm">{user && user?.role?.name || ""}</h6>
                      </div>
                      <div className="dsp-1">
                        <p>
                          <AiOutlineMail />
                        </p>
                        <div className="fly">
                          <a href="mailto:maheshsuthar083@gmail.com">{user && user?.email || ""}</a>
                        </div>
                        <div>
                        </div>
                      </div>
                      <div>
                        <Link to="/setting" style={{ textDecoration: "none" }}>
                          <p>Edit User</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* ----items-list-div----- */}
                  <div className="buttonn-hover">
                    <button onClick={handleLogout} className="bty">Logout</button>
                  </div>
                </ul>

              </div>
            </div>
          ) : null}
        </div>
      </div>

      <ActiveTaskModal
        isModalVisible={isActiveTaskModalVisible}
        closeModal={() => setIsActiveTaskModalVisible(false)}
        taskList={runningTasksList}  
        loading={loadingRunningTasks} 
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authenticationReducer.user,
    dashboardData: state.dashboardReducer.dashboardData
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardData: (id) => {
      dispatch(getDashboardData(id))
    },
    updateTask: (id, data, showToast) => {
      dispatch(updateTask(id, data, showToast))
    },
    getRunningTaskList: () => { 
      return dispatch(getRunningTaskList())
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
